import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import r1 from '/@/components/crop-monitoring/cards/assets/r1.svg';
import r6 from '/@/components/crop-monitoring/cards/assets/r6.svg';
import seed from '/@/components/crop-monitoring/cards/assets/seed.svg';
import v from '/@/components/crop-monitoring/cards/assets/v.svg';
import v1 from '/@/components/crop-monitoring/cards/assets/v1.svg';
import v2 from '/@/components/crop-monitoring/cards/assets/v2.svg';
import v3 from '/@/components/crop-monitoring/cards/assets/v3.svg';
import v4 from '/@/components/crop-monitoring/cards/assets/v4.svg';
import v5 from '/@/components/crop-monitoring/cards/assets/v5.svg';
import v6 from '/@/components/crop-monitoring/cards/assets/v6.svg';
import v7 from '/@/components/crop-monitoring/cards/assets/v7.svg';
import v8 from '/@/components/crop-monitoring/cards/assets/v8.svg';
import v9 from '/@/components/crop-monitoring/cards/assets/v9.svg';
import vt from '/@/components/crop-monitoring/cards/assets/vt.svg';
import { _ } from '/@/locale';
import type { CornStageChange } from '/@/types/crop-monitoring';

dayjs.extend(isBetween);

export const BASE_STEPS = [
    { displayName: 'S', state: 'SE', stage: 'emergence', phenology: 'sowing', image: seed },
    { empty: true, stage: 'emergence' },
    { displayName: 'VE', state: 'VE', stage: 'flowering', phenology: 'emergence', image: v },
    { empty: true, stage: 'flowering' },
    { displayName: 'V1', state: 'V1', stage: 'flowering', vegetativeStage: 1, image: v1 },
    { empty: true, stage: 'flowering', vegetativeStage: 1 },
    { displayName: 'V2', state: 'V2', stage: 'flowering', vegetativeStage: 2, image: v2 },
    { empty: true, stage: 'flowering', vegetativeStage: 2 },
    { displayName: 'V3', state: 'V3', stage: 'flowering', vegetativeStage: 3, image: v3 },
    { empty: true, stage: 'flowering', vegetativeStage: 3 },
    { displayName: 'V4', state: 'V4', stage: 'flowering', vegetativeStage: 4, image: v4 },
    { empty: true, stage: 'flowering', vegetativeStage: 4 },
    { displayName: 'V5', state: 'V5', stage: 'flowering', vegetativeStage: 5, image: v5 },
    { empty: true, stage: 'flowering', vegetativeStage: 5 },
    { displayName: 'V6', state: 'V6', stage: 'flowering', vegetativeStage: 6, image: v6 },
    { empty: true, stage: 'flowering', vegetativeStage: 6 },
    { displayName: 'V7', state: 'V7', stage: 'flowering', vegetativeStage: 7, image: v7 },
    { empty: true, stage: 'flowering', vegetativeStage: 7 },
    { displayName: 'V8', state: 'V8', stage: 'flowering', vegetativeStage: 8, image: v8 },
    { empty: true, stage: 'flowering', vegetativeStage: 8 },
    { displayName: 'V9', state: 'V9', stage: 'flowering', vegetativeStage: 9, image: v9 },
    { empty: true, stage: 'flowering', vegetativeStage: 9 },
    { displayName: 'V10', state: 'V10', stage: 'flowering', vegetativeStage: 10, image: v9 },
    { empty: true, stage: 'flowering', vegetativeStage: 10 },
    { displayName: 'V11', state: 'V11', stage: 'flowering', vegetativeStage: 11, image: v9 },
    { empty: true, stage: 'flowering', vegetativeStage: 11 },
    { displayName: 'V12', state: 'V12', stage: 'flowering', vegetativeStage: 12, image: v9 },
    { empty: true, stage: 'flowering', vegetativeStage: 12 },
    { displayName: 'V13', state: 'V13', stage: 'flowering', vegetativeStage: 13, image: v9 },
    { empty: true, stage: 'flowering', vegetativeStage: 13 },
    { displayName: 'V14', state: 'V14', stage: 'flowering', vegetativeStage: 14, image: v9 },
    { empty: true, stage: 'flowering', vegetativeStage: 14 },
    { displayName: 'V15', state: 'V15', stage: 'flowering', vegetativeStage: 15, image: v9 },
    { empty: true, stage: 'flowering', vegetativeStage: 15 },
    { displayName: 'V16', state: 'V16', stage: 'flowering', vegetativeStage: 16, image: v9 },
    { empty: true, stage: 'flowering', vegetativeStage: 16 },
    { displayName: 'V17', state: 'V17', stage: 'flowering', vegetativeStage: 17, image: v9 },
    { empty: true, stage: 'flowering', vegetativeStage: 17 },
    { displayName: 'V18', state: 'V18', stage: 'flowering', vegetativeStage: 18, image: v9 },
    { empty: true, stage: 'flowering', vegetativeStage: 18 },
    { displayName: 'V19', state: 'V19', stage: 'flowering', vegetativeStage: 19, image: v9 },
    { empty: true, stage: 'flowering', vegetativeStage: 19 },
    { displayName: 'R1', state: 'R', stage: 'maturity', phenology: 'flowering', image: vt },
    { empty: true, stage: 'maturity' },
    { displayName: 'MF', state: 'FM', stage: 'maturity', phenology: 'maturity', image: r1 },
    { empty: true, stage: 'harvested' },
    { displayName: 'C', state: 'H', stage: 'harvested', phenology: 'harvested', image: r6 },
];

export const getLabelStep = (
    vegetativeStage: number | undefined,
    phenology: string | undefined
): string | undefined => {
    if (phenology === 'maturity') return _('Madurez Fisiológica');
    if (phenology === 'flowering') return _('Floración');
    if (vegetativeStage) return `V${vegetativeStage}`;
    if (phenology === 'emergence') return _('Emergencia');
    if (phenology === 'harvested') return _('Cosecha');
    if (!phenology || phenology === 'sowing') return _('Siembra');
};

export const getFieldMonitoringLabelStep = (
    vegetativeStage: number | undefined,
    phenology: string | undefined,
    plantingDate: string | undefined
): string | undefined => {
    if (phenology === 'maturity') return _('Madurez');
    if (phenology === 'flowering') return _('Floración');
    if (vegetativeStage) return `V${vegetativeStage}`;
    if (phenology === 'emergence') return _('Emergencia');
    if (phenology === 'harvested') return _('Cosechado');
    if (phenology === 'sowing' || dayjs(plantingDate).isBefore(dayjs())) return _('Siembra');
    return _('Barbecho');
};

export const getActiveStepIndex = (lastStage: { vegetativeStage?: number; phenology?: string }) => {
    return BASE_STEPS.findIndex(
        (step) =>
            (lastStage.vegetativeStage !== undefined && step.vegetativeStage === lastStage.vegetativeStage) ||
            (lastStage.phenology !== undefined && step.phenology === lastStage.phenology)
    );
};

export const getActiveStep = (lastStage: { vegetativeStage?: number; phenology?: string }) => {
    if (!lastStage) return;
    const index = getActiveStepIndex(lastStage);
    if (index < 0) return;
    return BASE_STEPS[index];
};

export const geStageFromDate = (date: Dayjs, stages: CornStageChange[], plantingDate: Dayjs) => {
    const stage = stages.find((stage, i, array) => {
        const stageDate = dayjs(stage.date);
        const nextStageDate = i < array.length - 1 ? dayjs(array[i + 1].date) : null;
        if (!nextStageDate) return date.isAfter(stageDate) || date.isSame(stageDate);
        return date.isBetween(stageDate, nextStageDate, null, '[)');
    });

    if (!stage) {
        const firstStage = stages[0];
        if (!firstStage) return;

        if (date.isBetween(plantingDate, dayjs(firstStage.date), null, '[]')) {
            return {
                label: getLabelStep(undefined, undefined),
                step: BASE_STEPS[0],
            };
        }
    }

    const step = getActiveStep(stage);

    return {
        stage,
        step,
        label: getLabelStep(step?.vegetativeStage, step?.phenology),
    };
};

export const mergeStepsAndStages = (steps: any[], stages: any[], plantingDate: string) => {
    let updateSteps = [...steps];
    updateSteps[0].date = plantingDate;
    updateSteps = updateSteps.map((step) => {
        const equivalentStage = stages.find(
            (stage) =>
                (stage.vegetativeStage === step.vegetativeStage || stage.phenology === step.phenology) && !step.empty
        );
        if (equivalentStage) return { ...step, date: equivalentStage.date };
        return step;
    });
    return updateSteps;
};
